
import { mapState } from 'vuex';
import { Component, Prop, Watch } from 'vue-property-decorator';
import { BookingsApi } from '@/api/BookingsApi';
import { find, first, forEach, sortBy } from 'lodash';
import { downloadBlob } from 'download.js';
import b64toBlob from 'b64-to-blob';
import BasePage from '@/components/BasePage';

@Component({
   computed: {
      ...mapState({
         activities: (s: any) => s.activities.items,
         guides(s: any) {
            const guides: any[] = s.activities.guides;
            if (first(guides)?.id) {
               guides.unshift({ id: '', o_ability: '', o_endofemployment: '', o_name: '' });
            }
            return guides;
         },
         user_roles: (s: any) => s.users.roles,
         payment_colors: (s: any) => sortBy(s.activities.paymentColors, 'd_sort'),
         activities_colors: (s: any) => sortBy(s.activities.colors, 'd_sort'),
         tarification: (s: any) => s.activities.tarification,
         drivers(s: any) {
            const drivers: any[] = s.activities.drivers;
            if (first(drivers)?.id) {
               drivers.unshift({ id: '', o_id: '', o_name: '', o_status: '' });
            }
            return drivers;
         },
      }),

      tableFilteredColumns() {
         // @ts-ignore
         const columns = this.$options.filters['tableColumnFilter'](this.table_fields[this.tab_model]) as any[];
         return columns.filter(c => c.isHidden !== undefined);
      },
   },
   filters: {
      tableColumnFilter: (fields: any[], filter: boolean = false) => {
         fields = fields.filter(f => f?.isActive !== false);
         return filter ? fields.filter(f => f?.isVisible !== false) : fields;
      },
   },
})
export default class ActionActivitiesTabs extends BasePage {
   @Prop({ type: Object }) form!: any;

   @Prop({ type: Object }) items!: any;

   @Prop({ type: Array }) files!: any[];

   @Prop({ type: Number }) TotalAccommodationPrice!: number;

   @Prop({ type: Number }) TotalAccommodationCost!: number;

   form_table: any = {
      o_activities: [],
      o_extra_saling: [],
   };

   activities!: any[];

   guides!: any[];

   drivers!: any[];

   tarification!: any[];

   activities_colors!: any[];

   payment_colors!: any[];

   user_roles!: number[];

   tab_model: any = 0;

   table_fields: any[] = [];

   created() {
      const $columns = this.$localStorage.getItem(['activities', 'columns', 'visible'].join('-'), {});

      const o_activities = [
         {
            key: '0',
            label: 'status',
            thAttr: {
               style: 'width: 45px !important;',
            },
         },
         {
            key: '2',
            label: 'Activity',
            thAttr: {
               style: 'width: 250px !important',
            },
         },
         {
            key: '3',
            label: 'Activity day',
            thAttr: {
               style: 'width: 115px !important;',
            },
         },
         {
            key: '4',
            label: 'pax',
            thAttr: {
               style: 'width: 53px !important;',
            },
         },
         {
            key: '5',
            label: '🧍',
            headerTitle: 'Fact pax',
            thAttr: {
               style: 'width: 53px !important;',
            },
            isHidden: true,
         },
         {
            key: '6',
            label: 'Pick time',
            thAttr: {
               style: 'width: 63px !important;',
            },
         },
         {
            key: '25',
            label: 'Act. time',
            thAttr: {
               style: 'width: 63px !important;',
            },
         },
         /*{
     key: '7',
     label: 'Pickup place',
     thAttr: {
        style: 'width: 175px;',
     },
  },*/
         {
            key: '7',
            label: 'Activity Price €',
            thAttr: {
               style: 'width: 63px !important;',
            },
            isActive: !this.user_roles.includes(38),
         },
         {
            key: '8',
            label: 'Per',
            thAttr: {
               style: 'width: 63px !important;',
            },
            isActive: !this.user_roles.includes(38),
         },
         {
            key: '9',
            label: 'Total Act. Price €',
            thAttr: {
               style: 'width: 73px !important;',
            },
            isActive: !this.user_roles.includes(38),
         },
         {
            key: '10',
            label: '🚌',
            headerTitle: 'Cost Transf. €',
            thAttr: {
               style: 'width: 73px !important;',
            },
            isHidden: true,
         },
         {
            key: '11',
            label: '👧',
            headerTitle: 'Cost Guide €',
            thAttr: {
               style: 'width: 73px !important;',
            },
            isHidden: true,
         },
         {
            key: '12',
            label: '🍾',
            headerTitle: 'Cost Extra. €',
            thAttr: {
               style: 'width: 73px !important;',
            },
            isHidden: true,
         },
         {
            key: '13',
            label: 'Act. Cost €',
            thAttr: {
               style: 'width: 73px !important;',
            },
            isActive: !this.user_roles.includes(38),
         },
         {
            key: '14',
            label: 'Total Act. Cost €',
            thAttr: {
               style: 'width: 73px !important;',
            },
            isActive: !this.user_roles.includes(38),
         },
         {
            key: '15',
            label: 'Act. GP €',
            thAttr: {
               style: 'width: 73px !important;',
            },
            isActive: !this.user_roles.includes(38),
         },
         {
            key: '16',
            label: 'Transf. status',
            thAttr: {
               style: 'width: 45px !important;',
            },
         },
         {
            key: '17',
            label: 'Transfer',
            thAttr: {
               style: 'min-width: 100px !important;',
            },
         },
         {
            key: '18',
            label: 'Transfer notes (group)',
            thAttr: {
               style: 'min-width: 185px !important;',
            },
         },
         {
            key: '19',
            label: 'Transfer notes (driver)',
            thAttr: {
               style: 'min-width: 185px !important;',
            },
            isHidden: true,
         },
         {
            key: '20',
            label: 'Guide status',
            thAttr: {
               style: 'width: 45px !important;',
            },
         },
         {
            key: '21',
            label: 'Guide',
            thAttr: {
               style: 'width: 65px !important;',
            },
         },
         {
            key: '22',
            label: 'Guides notes',
            thAttr: {
               style: 'min-width: 150px !important;',
            },
            isHidden: true,
         },
         {
            key: '23',
            label: 'Supplier notes',
            thAttr: {
               style: 'min-width: 150px !important;',
            },
         },
         {
            key: '26',
            label: 'ACT PAY',
            thAttr: {
               style: 'width: 23px !important;',
            },
            isHidden: true,
         },
         {
            key: '27',
            label: 'TRANS PAY',
            thAttr: {
               style: 'width: 23px !important',
            },
            isHidden: true,
         },
         {
            key: '28',
            label: 'GUIDE PAY',
            thAttr: {
               style: 'width: 23px !important',
            },
            isHidden: true,
         },
         {
            key: '24',
            label: '',
            thAttr: {
               style: 'text-align: left; width: 24px !important;',
            },
            tdAttr: {
               style: 'vertical-align: middle;',
            },
         },
         {
            key: '29',
            label: '',
            thAttr: {
               style: 'width: 24px !important;',
            },
            tdAttr: {
               style: 'vertical-align: middle;',
            },
         },
      ].map(f => ({ ...f, isVisible: $columns[0] && $columns[0][f.key] !== undefined ? $columns[0][f.key] : true }));

      const o_extra_saling = [
         {
            key: '0',
            label: 'status',
            thAttr: {
               style: 'width: 43px;',
            },
         },
         {
            key: '2',
            label: 'Activity',
            thAttr: {
               style: 'width: 220px !important',
            },
         },
         {
            key: '3',
            label: 'Activity day',
            thAttr: {
               style: 'width: 115px;',
            },
         },
         {
            key: '4',
            label: 'pax',
            thAttr: {
               style: 'width: 53px;',
            },
         },
         {
            key: '5',
            label: '🧍',
            headerTitle: 'Fact pax',
            thAttr: {
               style: 'width: 53px;',
            },
            isVisible: true,
         },
         {
            key: '6',
            label: 'Pick time',
            thAttr: {
               style: 'width: 63px;',
            },
         },
         {
            key: '7',
            label: 'Pickup place',
         },
         {
            key: '8',
            label: 'Cost Danc. €',
            thAttr: {
               style: 'width: 73px;',
            },
         },
         {
            key: '9',
            label: 'Cost €',
            thAttr: {
               style: 'width: 73px;',
            },
         },
         {
            key: '10',
            label: 'Commis. €',
            thAttr: {
               style: 'width: 73px;',
            },
         },
         {
            key: '11',
            label: 'Price €',
            thAttr: {
               style: 'width: 73px;',
            },
         },
         {
            key: '12',
            label: 'Transfer',
         },
         {
            key: '13',
            label: 'Guides notes',
         },
         {
            key: '14',
            label: 'Supplier notes',
         },
         {
            key: '15',
            label: '',
            tdAttr: {
               style: 'vertical-align: middle;',
            },
         },
      ].map(f => ({ ...f, isVisible: $columns[1] && $columns[1][f.key] !== undefined ? $columns[1][f.key] : true }));

      this.table_fields = [o_activities, o_extra_saling];
   }

   mounted() {
      this.onChangeActivitiesItems();
   }

   findActivity(data: any[]) {
      return find(this.activities, { id: data[2] });
   }

   downloadFile(file_id: number) {
      const file: any = find(this.files, { file_id });
      downloadBlob(file.file_name, b64toBlob(file.base64));
   }

   deleteFile(file_id: number) {
      this.$store.commit('showLoading');
      BookingsApi.deleteFile(this.form.o_id, file_id)
         .then(() => {
            const item = find(this.files, { file_id });
            const index = this.files.indexOf(item);

            this.$emit(
               'change-files',
               this.files.filter((f, i) => i !== index)
            );
         })
         .finally(() => {
            this.$store.commit('hideLoading');
         });
   }

   uploadFiles(files: File[]) {
      this.$store.commit('showLoading');
      BookingsApi.uploadFiles(this.form.o_id, files)
         .then((data: any[]) => {
            let allFiles: any = this.files ? this.files : [];

            data.forEach((item: any) => {
               allFiles = [item, ...allFiles];
            });

            this.$emit('change-files', allFiles);
         })
         .finally(() => {
            this.$refs['upload-file']?.reset();
         });
   }

   isImage(base64: string) {
      const decode = atob(base64).toLowerCase();
      return (
         decode.indexOf('jfif') !== -1 ||
         decode.indexOf('jpg') !== -1 ||
         decode.indexOf('jpeg') !== -1 ||
         decode.indexOf('png') !== -1 ||
         decode.indexOf('gif') !== -1
      );
   }

   resizeTextArea(selector: string) {
      document.querySelector(selector)?.classList.toggle('textarea-sm');
   }

   @Watch('items', { deep: true })
   onChangeActivitiesItems(n?: any) {
      this.form_table = JSON.parse(JSON.stringify(this.items));
      console.log(n, this.form_table);
   }

   @Watch('form_table', { deep: true })
   onChangeFormActivities() {
      forEach(this.form_table, (items, table) => {
         if (JSON.stringify(this.form_table[table]) !== JSON.stringify(this.items[table])) {
            forEach(this.form_table[table], (item, index) => {
               if (Array.isArray(item)) {
                  forEach(item, (value, key) => {
                     const old = this.items[table][index];
                     if (typeof old[key] == undefined || value !== old[key]) {
                        console.log(table, { index, key, value });
                        this.$emit('update-activity-value', value, { index, item, field: { key } }, table);
                     }
                  });
               }
            });
         }
      });
   }

   @Watch('table_fields', { deep: true })
   onChangeColumnFilter() {
      const columns: any = { 0: {}, 1: {} };
      for (const i in this.table_fields) {
         forEach(this.table_fields[i], (f: any) => {
            columns[i][f.key] = f?.isVisible;
         });
      }
      this.$localStorage.setItem(['activities', 'columns', 'visible'].join('-'), columns);
   }
}
